import { IStoreWrap } from 'Shared/StoreProvider';
import { produce, reconcile} from 'solid-js/store';


export async function dbReplaceField<D>(sw:IStoreWrap<D>,field:string,value:any)
{
	sw.setStore?.(...sw.location,field,reconcile(value));

	if (sw.noDb) return;

	return await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:{[field]:value}});
}

export async function dbReplaceFields<D>(sw:IStoreWrap<D>,fields:any)
{
	sw.setStore?.(...sw.location,produce(parent => {
		for (const [name,value] of Object.entries(fields))
			parent[name] = value;
	}));

	if (sw.noDb) return;

	return await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:fields});
}


/* Merges fields into existing, overwriting the top-level fields that are included in value */
export async function dbMergeObject<D>(sw:IStoreWrap<D>,object:any)
{
	sw.setStore?.(...sw.location,produce(data => {
		for (const [key,value] of Object.entries(object))
			data[key] = value;
	}));

	if (sw.noDb) return;

	return await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:object});
}


export async function dbReplaceArray<D>(sw:IStoreWrap<D>,field:string,array:any[])
{
	sw.setStore?.(...sw.location,field,reconcile(array));

	if (sw.noDb) return;

	return await sw.server.replace.mutate({page:sw.page,permission:sw.permission,id:sw.docId,location:sw.location,fields:{[field]:array}});
}


